import { Component } from '@angular/core';
import { BackdropService } from '../../../services/backdrop/backdrop.service';

@Component({
    selector: 'lsq-backdrop',
    template: `
        <div *ngIf="backdropService.backdropStream | async">
            <div
                class="backdrop backdrop-visible"
                [ngClass]="{
                    'behind-content': backdropService.isBehindContent,
                    'white-backdrop': backdropService.isWhite
                }"
                (click)="handleBackdropClick()"
            ></div>
        </div>
    `,
    styleUrls: ['./lsq-backdrop.component.scss']
})
export class LsqBackdropComponent {
    constructor(public backdropService: BackdropService) {}

    public handleBackdropClick(): void {
        if (this.backdropService.onClick) {
            this.backdropService.onClick();
        }
        if (this.backdropService.closeOnClick) {
            this.backdropService.closeBackDrop();
        }
    }
}
